const iframeProps = {
  frameBorder: 1,
  height: 170,
  width: 340
};

export default {
  copied: "Copied!",
  copyText: "Copy HTML",
  iframeText: `<iframe width="${iframeProps.width}" height="${iframeProps.height}" frameborder="${iframeProps.frameBorder}" src="[athleteUrl]"></iframe>`,
  interestTitle: "Top School Interests",
  noInterests: "Prospect has no interests",
  philter: "prospect-embed"
};
